<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "@/router/index.js";
import moment from "moment";
import YTActivitySignOrderState from "@/components/YTActivitySignOrderState/index.vue";
import {userTokenStore} from "@/store/store.js";
import axios from "axios";
import {listOrderAll} from "@/api/order/order.js";

/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

// 报名状态枚举
const orderState = [
  {
    stateId: "UNPAID",
    stateName: "待支付",
  },
  {
    stateId: "WAIT_ACCEPT",
    stateName: "待接单",
  },
  {
    stateId: "PREPARING",
    stateName: "备餐中",
  },
  {
    stateId: "READY_FOR_PICKUP",
    stateName: "待取餐",
  },
  {
    stateId: "DELIVERING",
    stateName: "配送中",
  },
  {
    stateId: "CANCELLED",
    stateName: "已取消",
  },
  {
    stateId: "CLOSED",
    stateName: "已关闭",
  },
  {
    stateId: "COMPLETED",
    stateName: "已完成",
  },
  {
    stateId: "REFUNDING",
    stateName: "退款中",
  },
  {
    stateId: "REFUNDED",
    stateName: "已退款",
  },
  {
    stateId: "REGISTERED",
    stateName: "已报名",
  },
  {
    stateId: "USE_AVAILABLE",
    stateName: "可用",
  },
  {
    stateId: "PENDING",
    stateName: "待确认",
  },
  {
    stateId: "CONFIRMED",
    stateName: "已接单",
  },
  {
    stateId: "SERVING",
    stateName: "服务中",
  },
  {
    stateId: "REJECTED",
    stateName: "已拒绝",
  },
  {
    stateId: "CUSTOMER_SERVICE",
    stateName: "客服介入",
  }

]

/*搜索功能*/
// 表单数据
const formData = reactive({
  paymentNo: null,
  orderNo: null,
  orderState: null,
  paymentAmount: null,
  paymentTime: [],
  startPaymentTime: null,
  endPaymentTime: null
});
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true
    let param = {
      paymentNo: formData.paymentNo,
      orderNo: formData.orderNo,
      orderState: formData.orderState,
      paymentAmount: formData.paymentAmount,
      startPaymentTime: formData.paymentTime.length > 0 ? moment(formData.paymentTime[0]).format("YYYY-MM-DD HH:mm:ss") : null,
      endPaymentTime: formData.paymentTime.length > 0 ? moment(formData.paymentTime[1]).endOf('day').format("YYYY-MM-DD HH:mm:ss") : null,
    }
    const res = await listOrderAll(page, param);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.paymentNo = null
  formData.orderNo = null
  formData.paymentAmount = null
  formData.orderState = null
  formData.paymentTime = []
  formData.startPaymentTime = null
  formData.endPaymentTime = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '会员ID', key: 'memberId', nowrap: true },
  { title: '注册电话', key: 'phone', nowrap: true },
  { title: '订单金额', key: 'receivedAmount', nowrap: true },
  { title: '平台订单号', key: 'orderNo', nowrap: true },
  { title: '商户订单号', key: 'paymentNo', nowrap: true },
  { title: '订单状态', key: 'orderStateDesc', nowrap: true },
  { title: '支付时间', key: 'paymentTime', nowrap: true },
  { title: '订单类型', key: 'orderTypeDesc', nowrap: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*下载报表相关*/
// 处理下载订单列表
const handleDownloadList = async (item) => {
  // ElMessage.warning("下载中...");
  let param = {
    paymentNo: formData.paymentNo,
    orderNo: formData.orderNo,
    orderState: formData.orderState,
    paymentAmount: formData.paymentAmount,
    startPaymentTime: formData.paymentTime.length > 0 ? formData.paymentTime[0] : null,
    endPaymentTime: formData.paymentTime.length > 0 ? formData.paymentTime[1] : null,
  }
  await downloadFile(
      `${
          import.meta.env.VITE_API_URL
      }/admin/order/export`,
      param, // 请求体数据
      `平台订单报表-${moment().format(
          "YYYY-MM-DD_HHmmss"
      )}.csv` // 默认文件名
  );
};
/**
 * 自定义文件名的下载函数
 * @param {string} url - 完整接口URL
 * @param {Object} requestData - 请求体数据
 * @param {string} customFilename - 自定义文件名
 */
const downloadFile = async (url, requestData = {}, customFilename) => {
  try {
    const token = userTokenStore().token;
    const response = await axios.post(url, requestData, {
      responseType: "blob",
      headers: {
        Authorization: token.tokenValue,
        "Login-Type": token.loginType,
        "Content-Type": "application/json",
      },
    });

    // 创建下载链接
    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", customFilename); // 使用传入的自定义文件名
    document.body.appendChild(link);
    link.click();

    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    return true;
  } catch (error) {
    console.error("文件下载失败:", error);
    ElMessage.error("文件下载失败");
    return false;
  }
};

</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
        ref="ruleFormRef"
        style="width: 100%;text-align: left"
        :model="formData"
        label-width="auto"
        class="demo-ruleForm"
        status-icon
        label-position="top"
    >
      <div class="flex_left flex_warp">
        <el-form-item label="商户单号：" prop="paymentNo">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.paymentNo" placeholder="请输入商户单号"></el-input>
        </el-form-item>
        <el-form-item label="订单金额：" prop="paymentAmount">
          <el-input-number :precision="2" :min="0" class="mg_r_2" style="width: 300px;" v-model="formData.paymentAmount" placeholder="请输入订单金额"></el-input-number>
        </el-form-item>
        <el-form-item label="订单编号：" prop="orderNo">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.orderNo" placeholder="请输入订单编号"></el-input>
        </el-form-item>
        <el-form-item label="订单状态：" prop="orderState">
          <el-select class="mg_r_2" v-model="formData.orderState" placeholder="请选择订单状态" style="width: 300px">
            <el-option
                v-for="item in orderState"
                :key="item.stateId"
                :label="item.stateName"
                :value="item.stateId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="支付时间：" prop="paymentTime">
          <el-date-picker
              v-model="formData.paymentTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          />
        </el-form-item>
      </div>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <div class="flex_right mg_b_1">
      <v-btn
          color="#4CAF50"
          @click="handleDownloadList(drawerCache)"
      >
        导出
      </v-btn>
    </div>
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.orderStateDesc="{item}">
            <el-tag v-if="item.orderStateDesc === '待支付'" round type="warning" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '待接单'" round type="warning" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '备餐中'" round type="warning" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '待取餐'" round type="warning" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '配送中'" round type="primary" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '已取消'" round type="info" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '已关闭'" round type="info" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '已完成'" round type="success" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '退款中'" round type="warning" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '已退款'" round type="success" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '已报名'" round type="primary" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '可用'" round type="primary" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '待确认'" round type="warning" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '已接单'" round type="primary" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '服务中'" round type="primary" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '已拒绝'" round type="danger" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '客服介入'" round type="danger" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else round type="info">未知状态</el-tag>
          </template>

          <template v-slot:item.orderTime="{item}">
            {{item.orderTime ? moment(item.orderTime).format("YYYY-MM-DD") : '-'}}
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="getDetail(item)"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>
